import { classNames } from '@dimjs/utils';
import { CSSProperties } from 'react';
import { CommonPropsWithChildren } from '../../utils/native-props';
import './style.less';

export type TitleProps = {
  sbuTitle?: string | JSX.Element;
  leftLine?: boolean;
} & CommonPropsWithChildren<{
  '--v-title-color': CSSProperties['color'];
  '--v-title-sub-color': CSSProperties['color'];
}>;
export const Title = (props: TitleProps) => {
  return (
    <div
      className={classNames('v-title', { 'v-title-line': props.leftLine }, props.className)}
      style={props.style}
    >
      <div className="v-title-title">{props.children}</div>
      {props.sbuTitle && <div className="v-title-sbutitle">{props.sbuTitle}</div>}
    </div>
  );
};
